import { useEffect, useRef } from 'react';
import './ChatWindow.css';

interface Message {
  id: string;
  text: string;
  isUser: boolean;
  timestamp?: Date;
}

interface MessageListProps {
  messages: Message[];
}

function MessageList({ messages }: MessageListProps) {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    // block: 'nearest' keeps the scroll inside the list, so the page that
    // embeds this iframe is never scrolled along with it.
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  if (messages.length === 0) {
    return (
      <div className="message-list">
        <div className="welcome-message">
          <h2>Welcome to EFSoft Chat</h2>
          <p>How can we help today? Ask us anything about our services.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="message-list" role="log" aria-live="polite" aria-label="Conversation">
      {messages.map((message) => (
        <div key={message.id} className={`message ${message.isUser ? 'user' : 'ai'}`}>
          <div className="message-bubble">
            <span className="sr-only">{message.isUser ? 'You: ' : 'EFSoft: '}</span>
            <p className="message-text">{message.text}</p>
            {message.timestamp && (
              <div className="message-timestamp">
                {message.timestamp.toLocaleTimeString([], { 
                  hour: '2-digit', 
                  minute: '2-digit' 
                })}
              </div>
            )}
          </div>
        </div>
      ))}
      <div ref={messagesEndRef} />
    </div>
  );
}

export default MessageList;
